import * as React from 'react';
import { LogisticsTabData, RoutePracticesTab } from '../Tabs';
import { PickUp } from '../Pickup';
import PropTypes from 'prop-types';
import { Tab, Tabs, Box, styled } from '@mui/material';
import { useSelector } from 'react-redux';
import RouteIcon from '@mui/icons-material/Route';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const TabsCustomization = React.forwardRef((props, lastElementRef) => {
  const { value, setValue } = props;

  // Subscribing To Store for assigned and Enrouted Practices
  const assignedPractices = useSelector(
    (state) => state.practicesReducer.practices
  );
  const enroutedPractices = useSelector(
    (state) => state.practicesReducer.enroutedPractices
  );

  // Event Handler for tab switch
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const StyledTabs = styled((props) => <Tabs {...props} />)({
    '& .MuiTabs-indicator': {
      backgroundColor: 'transparent',
    },
    '& .MuiTab-root.Mui-selected': {
      backgroundColor: '#054E8B',
      color: '#ffffff',
      fontWeight: '700',
      lineHeight: '20px',
      fontFamily: 'Mukta',
    },
    '& .MuiTab-root': {
      margin: '0px',
      fontSize: '15px',
      lineHeight: '19px',
      minHeight: '40px',
      fontWeight: '400',
      fontFamily: 'Mulish',
    },
    '&.MuiTabs-root': {
      minHeight: '40px',
      justifyContent: 'space-between',
    },
  });

  const StyledTab = styled((props) => <Tab {...props} />)(({ theme }) => ({
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
  }));

  return (
    <Box sx={{ width: '100%' }}>
      <StyledTabs
        value={value}
        onChange={handleChange}
        aria-label="styled tabs example"
      >
        <StyledTab
          icon={<RouteIcon sx={{ fontSize: '1rem' }} />}
          {...a11yProps(0)}
          sx={{ '& .MuiTab-root.Mui-selected': { color: '#112233' } }}
          style={{
            minWidth: '10%',
            padding: '4px 8px',
            display: 'flex',
            flexDirection: 'row-reverse',
            justifyContent: 'space-around',
          }}
        />
        <StyledTab
          label="Pick Ups"
          {...a11yProps(1)}
          sx={{ '& .MuiTab-root.Mui-selected': { color: '#112233' } }}
          style={{
            minWidth: '30%',
            padding: '4px 8px',
            display: 'flex',
            flexDirection: 'row-reverse',
            justifyContent: 'space-around',
          }}
        />
        <StyledTab
          label="Collected"
          {...a11yProps(2)}
          style={{
            minWidth: '30%',
            padding: '4px 8px',
          }}
        />
        <StyledTab
          label="Delivered"
          {...a11yProps(3)}
          style={{
            minWidth: '30%',
            padding: '4px 8px',
          }}
        />
      </StyledTabs>
      <TabPanel value={value} index={0}>
        <Box
          sx={{
            height: 'calc(100vh - 204px)',
            overflowY: 'auto',
            mt: '-1px',
          }}
        >
          <RoutePracticesTab
            practices= { props.searchedRoutePractices || assignedPractices }
            route_name={props.route_name}
            tabIndex={props.value}
            searchValue={props.searchValue}
            locationCoordinates={props.locationCoordinates}
          />
        </Box>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Box
          sx={{
            height: 'calc(100vh - 204px)',
            overflowY: 'auto',
            mt: '-1px',
          }}
        >
          <LogisticsTabData
            assignedPractices={assignedPractices}
            enroutedPractices={enroutedPractices}
            locationCoordinates={props.locationCoordinates}
            dropDownHeight={props?.dropDownHeight}
            setDropDownHeight={props?.setDropDownHeight}
            apply={props.apply}
            setApply={props.setApply}
            ref={lastElementRef}
            tabIndex={props.value}
          />
        </Box>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Box
          sx={{
            height: 'calc(100vh - 210px)',
            overflowY: 'auto',
            mt: '-1px',
          }}
        >
          <PickUp
            practiceOrdersData={assignedPractices}
            locationCoordinates={props.locationCoordinates}
            currentValue="Collected"
            apply={props.apply}
            setApply={props.setApply}
            dropDownHeight={props.dropDownHeight}
            setDropDownHeight={props.setDropDownHeight}
            tabIndex={props.value}
            ref={lastElementRef}
          />
        </Box>
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Box
          sx={{
            height: 'calc(100vh - 205px)',
            overflowY: 'auto',
            mt: '-1px',
          }}
        >
          <PickUp
            practiceOrdersData={assignedPractices}
            locationCoordinates={props.locationCoordinates}
            currentValue="Delivered"
            apply={props.apply}
            setApply={props.setApply}
            dropDownHeight={props.dropDownHeight}
            setDropDownHeight={props.setDropDownHeight}
            ref={lastElementRef}
            tabIndex={props.value}
          />
        </Box>
      </TabPanel>
    </Box>
  );
});
TabsCustomization.displayName = 'TabsCustomization';
TabsCustomization.propTypes = {
  apply: PropTypes.bool.isRequired,
  setApply: PropTypes.func.isRequired,
  dropDownHeight: PropTypes.bool.isRequired,
  locationCoordinates: PropTypes.object,
  setDropDownHeight: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
  setValue: PropTypes.func.isRequired,
  route_name: PropTypes.string,
  searchedRoutePractices: PropTypes.array,
  searchValue: PropTypes.string.isRequired,
};
export default TabsCustomization;
